export class BallPointPenJsEnv {
  ballpointPenMakers: string[];
  ballPointPenSeries: string[];
  ballPointPenSizes: string[];
  selectedMaker: string;
  selectedSeries: string;
  selectedSize: string;

  constructor(
    ballpointPenMakers: string[],
    ballPointPenSeries: string[],
    ballPointSizes: string[],
    selectedMaker: string,
    selectedSeries: string,
    selectedSize: string
  ) {
    this.ballpointPenMakers = ballpointPenMakers;
    this.ballPointPenSeries = ballPointPenSeries;
    this.ballPointPenSizes = ballPointSizes;
    this.selectedMaker = selectedMaker;
    this.selectedSeries = selectedSeries;
    this.selectedSize = selectedSize;
  }
}